import React, { useState, useContext, Suspense, lazy } from "react";

import "./styles/login.css";

import { RootContext } from "./RootContext"; 
import bcrypt from "bcryptjs"

const App = lazy(() => import("./pages/_app"));

function Login() {
  // React States
  const [errorMessages, setErrorMessages] = useState({});

  const userContextRef = useContext(RootContext);
  const errors = {
    uname: "Wrong credential!",
    pass: "Wrong credential!"
  };

  const handleSubmit = async (event) => {
    //Prevent page reload
    event.preventDefault();

    var { uname, pass } = document.forms[0];

    fetch('https://crazgss0cl.execute-api.ap-southeast-1.amazonaws.com/authenticate/'+uname.value)
    .then(result => result.json())
    .then(rowData => {
       if(rowData === "-1") {
            setErrorMessages({ name: "pass", message: errors.uname });
       } else {
            if (rowData.Item && rowData.Item.hash) {
              const verifyLogin = bcrypt.compareSync(pass.value, rowData.Item.hash);
              if (verifyLogin === true) {
                  userContextRef.setAuthenticated(true);
                  window.sessionStorage.setItem('authenticated', 'true');
                  userContextRef.setAuthBody('mfb');
                  window.sessionStorage.setItem('authBody', 'mfb');
                  window.sessionStorage.setItem('authUser', rowData.Item.name);
                  window.sessionStorage.setItem('authUserId', rowData.Item.userId);
                  window.sessionStorage.setItem('authRole', rowData.Item.role);
              } else {
                  setErrorMessages({ name: "pass", message: errors.pass });
              }
            } else {
              setErrorMessages({ name: "pass", message: errors.uname });
            }
       }
    });
  };

  // Generate JSX code for error message
  const renderErrorMessage = (name) =>
    name === errorMessages.name && (
      <div className="error">{errorMessages.message}</div>
    );

  // JSX code for login form
  const renderForm = (
    <div className="login-page">
      <form onSubmit={handleSubmit} className="app-card">
        <legend>模范班 登入</legend>
        <div className="input-container">
          <label htmlFor="login-username">用户名</label>
          <input id="login-username" type="text" name="uname" autoComplete="username" required />
        </div>
        <div className="input-container">
          <label htmlFor="login-password">密码</label>
          <input id="login-password" type="password" name="pass" autoComplete="current-password" required />
          {renderErrorMessage("pass")}
        </div>
        <div className="button-container">
          <input type="submit" value="登入" />
        </div>
      </form>
    </div>
  );

  return (
    <div>
      {userContextRef.authenticated === true ||
      userContextRef.authenticated === 'true' ? (
        <Suspense fallback={<div className="login-page">加载中…</div>}>
          <App />
        </Suspense>
      ) : (
        renderForm
      )}
    </div>
  );
}

export default Login;